import type { CoreError } from '@ingenico/api-sdk-core/common';
import { LNGS_NAMESPACE_CONFIGURATION_PROFILE } from '@ingenico/util-i18n-config';
import type { ReactConfigurationGeneratorApi } from '@ingenico/react-configuration-generator';
import { CategoryEnum } from '@ingenico/react-configuration-generator';
import { toString } from 'lodash-es';
import type { TFunction } from 'react-i18next';

export function verifyShouldSubscribeLoadingConfiguration({
  selectedCategory,
  hasData,
  selectedApplicationId,
  isSubscribed,
}: {
  readonly hasLoadedRootConfigRef?: boolean;
  readonly selectedCategory?: CategoryEnum;
  readonly hasData?: boolean;
  readonly selectedApplicationId?: string;
  readonly isSubscribed?: boolean;
}): boolean {
  return !!selectedCategory && !!hasData && !!selectedApplicationId && !isSubscribed;
}

export function handleExpandAppAccordion(
  selectedApplicationId: string,
  config?: ReactConfigurationGeneratorApi | null,
  selectedCategory?: CategoryEnum,
  scrollElementToTop?: (element: HTMLDivElement) => void,
): void {
  if (selectedCategory === CategoryEnum.Apps) {
    config?.handleExpandAppAccordion(toString(selectedApplicationId), true, scrollElementToTop);
  } else if (selectedCategory === CategoryEnum.Sp) {
    config?.handleExpandSpAccordion(toString(selectedApplicationId), true, scrollElementToTop);
  }
}

export function getConfigurationError(t: TFunction, error?: CoreError): string {
  switch (error?.status) {
    case 404: {
      return t('error.default.notFound', { ns: LNGS_NAMESPACE_CONFIGURATION_PROFILE.DEFAULT });
    }
    default: {
      return t('error.default.fetch', { ns: LNGS_NAMESPACE_CONFIGURATION_PROFILE.DEFAULT });
    }
  }
}
